import { Itinerary } from './der-content-itinerary.component';
export * from './der-content-itinerary.component';
export default Itinerary;

Itinerary.define('der-content-itinerary');

declare global {
    interface HTMLElementTagNameMap {
        'der-content-itinerary': Itinerary;
    }
}
